import {useEffect} from 'react';
import {DEFAULT_LOADING_TOAST_BOTTOM_OFFSET, setBottomOffsetAction} from '@Components/loading-toast';
import {EditorViewport} from '@EmailMakerReact/email-maker-react.types';
import {useAppDispatch} from '@/hooks';

/** 80px bottom-bar height + 16px gap, keeping the global loading toast clear of the bar on mobile/tablet. */
const EMAIL_MAKER_BOTTOM_BAR_TOAST_OFFSET = 96;

/** Raises the global loading toast above the email-maker bottom bar while it is shown (non-desktop), resetting on desktop/unmount. */
export function useLoadingToastBottomOffset(editorViewport: EditorViewport): void {
  const dispatch = useAppDispatch();

  useEffect((): (() => void) | undefined => {
    if (editorViewport === EditorViewport.DESKTOP) {
      return undefined;
    }

    dispatch(setBottomOffsetAction(EMAIL_MAKER_BOTTOM_BAR_TOAST_OFFSET));

    return (): void => {
      dispatch(setBottomOffsetAction(DEFAULT_LOADING_TOAST_BOTTOM_OFFSET));
    };
  }, [editorViewport, dispatch]);
}
